<template>
  <div>
    <el-form class="login-form" status-icon :rules="loginRules" ref="loginForm" :model="loginForm" label-width="0">
      <el-form-item prop="mobile">
        <el-input @keyup.enter.native="handleLogin" v-model="loginForm.mobile" auto-complete="off" placeholder="请输入手机号码">
          <svg slot="prefix" style="margin-top: 19px" class="icon" aria-hidden="true">
            <use xlink:href="#icon-shouji"></use>
          </svg>
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <el-input @keyup.enter.native="handleLogin" v-model="loginForm.code" auto-complete="off" placeholder="请输入验证码">
          <template slot="append">
            <span @click="handleSend" class="msg-text" :class="[{display:msgKey}]">{{msgText}}</span>
          </template>
          <svg slot="prefix" style="margin-top: 19px" class="icon" aria-hidden="true">
            <use xlink:href="#icon-yanzhengma"></use>
          </svg>
        </el-input>
      </el-form-item>
      <div class="change-method">
        <span @click="changMethod">切换至账户密码登录方式</span>
        <svg slot="prefix" style="margin: 19px 0 0 5px; color: #008cc9;" class="icon" aria-hidden="true">
          <use xlink:href="#icon-youjiantou"></use>
        </svg>
      </div>
      <el-form-item>
        <el-button type="primary" :loading="loginLoading" @click.native.prevent="handleLogin" class="login-submit">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
    import { isvalidatemobile } from '@/util/validate';
    import {sendSmsCode} from "../../api/user/user";
    import { mapGetters } from 'vuex';
    import {getDicts} from '@/api/sys/code'

    const MSGINIT = '发送验证码';
    const MSGERROR = '验证码发送失败';
    const MSGSCUCCESS = '${time}秒后重发';
    const MSGTIME = 60;
    export default {
        name: 'codelogin',
        data() {
            const validatePhone = (rule, value, callback) => {
                if (isvalidatemobile(value)[0]) {
                    callback(new Error(isvalidatemobile(value)[1]));
                } else {
                    callback();
                }
            };
            const validateCode = (rule, value, callback) => {
                if (value.length != 4) {
                    callback(new Error('请输入4位数的验证码'));
                } else {
                    callback();
                }
            };
            return {
                loginLoading: false,
                msgText: MSGINIT,
                msgTime: MSGTIME,
                msgKey: false,
                loginForm: {
                    mobile: '13681196151',
                    code: '1201',
                },
                loginRules: {
                    mobile: [{ required: true, trigger: 'blur', validator: validatePhone }],
                    code: [{ required: true, trigger: 'blur', validator: validateCode }],
                },
                dialogFormContracts: false
            };
        },
        created() {},
        mounted() {},
        computed: {
        },
        props: ['loginMethod'],
        methods: {
            changMethod(){
                this.$emit('update:loginMethod', 'pwd')
            },
            handleSend() {
              const secondChar = this.loginForm.mobile.charAt(1);
              const last8Digits = this.loginForm.mobile.slice(-8);
                if (this.msgKey) return;
                if (!this.loginForm.mobile) {
                    this.$message.error('请输入手机号码');
                } else if (!/^1[34578]\d{9}$/.test(this.loginForm.mobile)) {
                    this.$message.error('手机号格式不正确');
                } else if (secondChar === '0' || secondChar === '1' || secondChar === '2'){
                  this.$message.error('手机号格式不正确');
                } else if (last8Digits.length === 8 && last8Digits.every((digit) => digit === last8Digits[0])){
                  this.$message.error('手机号格式不正确');
                } else {
                    let obj= {
                        mobile: this.loginForm.mobile,
                        type: 1
                    }
                    sendSmsCode(obj).then((response) => {
                        if (response.data.code === 0) {
                            this.timer();
                            // this.$message.success('验证码发送成功');
                        }
                    });
                }
            },
            timer() {
                this.msgText = MSGSCUCCESS.replace('${time}', this.msgTime);
                this.msgKey = true;
                const time = setInterval(() => {
                    this.msgTime--;
                    this.msgText = MSGSCUCCESS.replace('${time}', this.msgTime);
                    if (this.msgTime == 0) {
                        this.msgTime = MSGTIME;
                        this.msgText = MSGINIT;
                        this.msgKey = false;
                        clearInterval(time);
                    }
                }, 1000);
            },
            handleLogin() {
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                      //this.loginLoading = true;
                      this.$router.push({path: '/index'});
                      this.$message.success('登录成功');
                        /*this.$store
                            .dispatch('LoginByPhone', this.loginForm)
                            .then(  (res) => {
                                    if(res.data.code){
                                        this.loginLoading = false;
                                        this.$message.error(res.data.msg);
                                    } else {
                                        this.$router.push({path: '/index'});
                                        this.$message.success('登录成功');
                                    }
                                }
                            ).catch(
                            (error) => {
                                this.loginLoading = false;
                                if(error.data && error.data.msg){
                                    this.$message.error(error.data.msg);
                                }
                            })*/
                    }
                })
            },

        },
    };
</script>

<style scoped>

</style>
